var map = {
	"./hat_8BitTT Classic Black.png": 9406,
	"./hat_8BitTT Orange Logo.png": 7887,
	"./hat_8BitTT Sunday Black.png": 6449,
	"./hat_Adventurer Hat.png": 5534,
	"./hat_Birdie Cap.png": 6259,
	"./hat_Cowboy Hat.png": 7992,
	"./hat_Crown.png": 7210,
	"./hat_Dunce Cap.png": 1032,
	"./hat_FriendTech Ears.png": 3584,
	"./hat_Headphones.png": 5868,
	"./hat_Knight's Helm.png": 1224,
	"./hat_LUMI Cap.png": 3268,
	"./hat_Mask Bobo.png": 9271,
	"./hat_Mask Mumu.png": 5895,
	"./hat_Mask Pepe.png": 2422,
	"./hat_McWagies.png": 6598,
	"./hat_Milarfy Cake Hat.png": 9980,
	"./hat_Party Hat 1.png": 9665,
	"./hat_Party Hat 2.png": 3272,
	"./hat_Plumber Hat 1.png": 6802,
	"./hat_Plumber Hat 2.png": 3618,
	"./hat_Sombrero.png": 5540,
	"./hat_Spartan Helm.png": 3604,
	"./hat_Tinfoil Hat.png": 2386,
	"./hat_Visor.png": 6775,
	"./hat_WIF hat.png": 4329
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 5605;